import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { IconUIComponent } from '../icon/icon.component';

@Component({
  selector: 'fr8bot-ui-page-filters-clear-button',
  imports: [IconUIComponent],
  templateUrl: './page-filters-clear-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageFiltersClearButtonUIComponent {
  readonly clear = output();
}
